/* eslint-disable react/prop-types */
import { styled } from '@mui/material/styles';
import { Container } from '@mui/material';

const WrapperContainerPublic = styled(Container)({
  backgroundColor: '#212121'
});

export default WrapperContainerPublic;
